module.exports = __webpack_public_path__ + "img/1518633250.7363c89c.jpg";